export class Product {
   constructor(id, code, name, price, iva, ieps, cost, brand,box_pieces, stock, line_id,
      presentation_id, brand_id, category_id, is_beer = false, is_souvenir = false, img_url = null, is_exist = false){
      this.id = id
      this.code = code
      this.name = name
      this.price = price
      this.iva = iva
      this.ieps = ieps
      this.cost = cost
      this.brand = brand
      this.box_pieces = box_pieces
      this.stock = stock

      this.line_id = line_id
      this.presentation_id = presentation_id
      this.brand_id = brand_id
      this.category_id = category_id

      this.img_url = img_url

      // es cerveza?
      this.is_beer = is_beer

      // es souvenir ?
      this.is_souvenir = is_souvenir

      // validar si existe en cart
      this.is_exist = is_exist
   }

   static getListImgUrl(product){
    
      // retornar imagen sin redimensionar para vista de producto
      //return product.img_url;
      /*if(Product.setDimensionsToUrl(product.img_url, 250, 250) != null){
         return product.img_url;
      }
      return null;*/
      return Product.setDimensionsToUrl(product.img_url, 250, 250)
   }

   static getCartImgUrl(product){
    
      return Product.setDimensionsToUrl(product.img_url, 125, 125);
   }

   static getCheckoutImgUrl(product){
      return Product.setDimensionsToUrl(product.img_url, 40, 40);
   } 

   static setDimensionsToUrl(url, w, h){
      if(!Product.isEmptyUrl(url)){
         // inject dimensions to url
         const arr = url.split("/");
         if(arr.length > 1){
            let newUrl = "";
            for (let i = 0; i < arr.length; i++) {
               if(i == arr.length -1){
                  newUrl += `${w}x${h}/${arr[i]}`;
               }
               else {
                  newUrl += arr[i] + "/";
               }
            }
            return newUrl;
         }
      }
      return null;
   }

   static isEmptyUrl(url){
      return !(url && url.trim().length);
   }

   static fromServiceProduct (prod) {
      return new Product(
         prod.id_producto,
         prod.codigo,
         prod.nombre,
         parseFloat(prod.precio),
         parseFloat(prod.iva),
         parseFloat(prod.ieps),
         parseFloat(prod.importe),
         prod.marca,
         prod.piezas_paquete,
         prod.stock,
         prod.id_linea,
         prod.id_presentacion,
         prod.id_marca,
         prod.id_categoria,
         prod.cerveza,
         prod.souvenir,
         prod.url_imagen,
         prod.exist
      );
   }
}